module.exports = __webpack_public_path__ + "img/teishoku.9803d86e.png";